import { render, staticRenderFns } from "./SmsNumberToActivate.vue?vue&type=template&id=0b774d4f&"
import script from "./SmsNumberToActivate.vue?vue&type=script&lang=js&"
export * from "./SmsNumberToActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports